import { FormEventHandler, ReactNode, useContext, useEffect, useState } from 'react';
import {
	Card,
	CardContent,
	Button,
	Typography,
	TextField,
	CircularProgress,
	Box,
	Grid,
	Stack,
	Link,
	CardActionArea,
	useTheme,
	useMediaQuery,
} from '@mui/material';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import LoginPageImage from '../../assets/images/background/OrangeChevron_Cropped_2000x1888.png';
import Deltorian from '../../assets/images/deltorian/Deltorian.svg';
import CardTitleLogo from '../../assets/images/logos/OrangeArrows.svg';
import Header from '../Header';

interface LoginPageProps {
    cardTitle: string;
    onSubmit?: FormEventHandler<HTMLFormElement> | undefined;
    HeaderComponent?: ReactNode;
    SubtitleComponent?: ReactNode | string;
    FooterComponent?: ReactNode;
    FooterActions?: ReactNode;
    children?: ReactNode;
}
const LoginPageLayout = ({ cardTitle, onSubmit, HeaderComponent, SubtitleComponent, FooterComponent, FooterActions, children } : LoginPageProps) => {
	const theme = useTheme();

	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
	const isSmallScreen = useMediaQuery(theme.breakpoints.only('sm'));
	const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'));
	const is915pxOrGreater = useMediaQuery(theme.breakpoints.up('loginImage'));

	return (
		<div style={{ height: '100vh', width: '100vw' }}>
			<Header />
			<Box
				sx={{
					position: 'absolute',
					bottom: 0,
					left: 0,
					height: '91.5%',
					width: is915pxOrGreater ? '915px' : '100vw',
					backgroundImage: `url(${LoginPageImage})`,
					backgroundPosition: 'left',
					backgroundSize: 'cover',
					backgroundRepeat: 'no-repeat',
					display: 'flex',
					flexDirection: 'column',
				}}
			/>
			<Box
				sx={{
					position: 'relative',
					height: '91.5%',
					width: '100%',
					display: 'flex',
					flexDirection: 'column',
					zIndex: 1,
				}}
			>
				<Grid container alignItems='center' p={5} height='100%'>
					{isLargeScreen && <Grid item lg={1} />}
					{!isMobile && (
						<Grid
							item
							xs={false}
							sm={true}
							display='flex'
							justifyContent='flex-end'
							pr='5em'
						>
							<Box
								height={isLargeScreen ? '40vh' : isSmallScreen ? '100%' : '30vh'}
								width={isLargeScreen ? '40vh' : isSmallScreen ? '100%' : '30vh'}
							>
								<img src={Deltorian} alt='Deltorian' />
							</Box>
						</Grid>
					)}

					<Grid item xs={12} sm={7} md={6} lg={5} px={isMobile ? 3 : 5}>
						<Card
							component='form'
							{...onSubmit && { onSubmit }}
						>
							<CardContent>
								<Stack
									direction='row'
									justifyContent='space-between'
									alignItems='center'
									spacing={2}
									pb='1em'
								>
									<Stack direction='row' alignItems='center'>
										<img
											src={CardTitleLogo}
											alt='Card Header Logo'
											style={{ height: '1.5em' }}
										/>
										<Typography variant='cardHeader'>{cardTitle}</Typography>
									</Stack>
                                    {HeaderComponent ?? <></>}
								</Stack>
								{SubtitleComponent && <Typography variant='subtitle1'>
                                    {SubtitleComponent}
								</Typography>}
								<Stack spacing={2} py={3}>
                                    {children}
								</Stack>
                                {FooterComponent ?? <></>}
								
								{FooterActions && <Box display='flex' justifyContent='center' pt='2em'>
                                    {FooterActions}
								</Box>}
							</CardContent>
						</Card>
					</Grid>
				</Grid>
			</Box>
		</div>
	);
};

export default LoginPageLayout;
